import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  postGroupMessageFailure,
  postGroupMessageSuccess,
} from "../slices/features/groupMessages";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* psotGroupMessageSaga(action: any) {
  const { payload } = action;
  const { id, groupId, data } = payload;
  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appservice.postGroupMessages,
      baseUrl,
      id,
      groupId,
      data
    );

    yield put(postGroupMessageSuccess({ ...response }));
    payload?.cbSuccess && payload?.cbSuccess({ ...response });
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const message = error?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(postGroupMessageFailure({ statusCode, statusText }));
  }
}

export function* watchPostGroupMessages() {
  yield takeLatest(
    RequestTypes.POST_GROUP_MESSAGE_REUQEST,
    psotGroupMessageSaga
  );
}
